import {message} from "antd";

export function  formattedNowDate(){
    const date = new Date();

    // 获取年份、月份、日期
    const year = date.getFullYear();
    const month = date.getMonth() + 1;  // 月份从0开始，所以需要加1
    const day = date.getDate();

    // 获取星期几
    const weekdays = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
    const weekday = weekdays[date.getDay()-1];

    // 格式化日期为 "2024年11月24日 星期日"
    const today = `${year}年${month}月${day}日 ${weekday}`;
    return today;
}

export const showWarning = (content: string, afterClose?: () => void) => {
    message.warning({
        content,
        duration: 1.5,
        onClose: afterClose
    })
}

export const showSuccess = (content: string, afterClose?: () => void) => {
    message.success({
        content,
        duration: 1.5,
        onClose: afterClose
    })
}


export const showFail = (content: string, afterClose?: () => void) => {
    message.error({
        content,
        duration: 1.5,
        onClose: afterClose
    })
}

export const fileBaseUrl=() =>  {
    return "https://lsc.hzlsst.com/file/"
}